import React, { useContext } from 'react';
import { Container } from '@material-ui/core';
import education from '../../assets/lottie/education.json';
import { ThemeContext } from '../../contexts/ThemeContext';
import { educationData } from '../../data/educationData';
import EducationCard from './EducationCard';
import AnimationLottie from '../Animation';
import './Education.css';

function Education() {
    const { theme } = useContext(ThemeContext);

    const styles = {
        wrapper: { backgroundColor: theme.secondary },
        title: { color: theme.primary }
    };

    return (
        <div style={styles.wrapper}>
            <Container className="education" id="resume">
                <div className="education-body">
                    <div className="education-image">
                        <AnimationLottie animationPath={education} />
                    </div>
                    
                    <div className="education-description">
                        <h1 style={styles.title}>Education</h1>
                        {educationData.map((edu) => (
                            <EducationCard key={edu.id} {...edu} />
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default Education;